export default "__VITE_ASSET__KQyxP11o__"